<app-entity-mat-dialog-title title="Schedule Gift Certificate Email"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <p class="mb-1"><strong>Certificate:</strong> {{ certificate?.field_gift_certificate_code }}</p>
  <p class="mb-3"><strong>Recipient:</strong> {{ certificate?.field_recipient_name }} &lt;{{ certificate?.field_recipient_email }}&gt;</p>

  <p class="text-muted" *ngIf="alreadySent">
    This certificate was emailed on {{ reportDateService.formatDate(certificate.email_sent_date) }}.
    To send it again, use Resend Email.
  </p>

  <ng-container *ngIf="!alreadySent">
    <p class="text-muted" *ngIf="certificate?.field_email_send_date">
      Currently scheduled for {{ reportDateService.formatDate(certificate.field_email_send_date) }}.
    </p>
    <p class="text-muted" *ngIf="!certificate?.field_email_send_date">
      Not scheduled. It will only be sent when someone clicks Send Email.
    </p>

    <mat-form-field class="full-width-field">
      <mat-label>Email the certificate on</mat-label>
      <input matInput
             [owlDateTime]="sendDatePicker"
             [owlDateTimeTrigger]="sendDatePicker"
             [(ngModel)]="sendDate"
             [ngModelOptions]="{standalone: true}"
             [min]="minDate"
             placeholder="Select a date"
             readonly>
      <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="sendDatePicker">
        <mat-icon>calendar_today</mat-icon>
      </span>
      <owl-date-time #sendDatePicker [pickerType]="'calendar'"></owl-date-time>
      <mat-hint>Sent that morning in the studio's timezone</mat-hint>
    </mat-form-field>
  </ng-container>

  <app-error-message [message]="errorMessage"></app-error-message>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" type="button" (click)="_dialogRef.close()">Cancel</button>
  <button *ngIf="!alreadySent && certificate?.field_email_send_date"
          mat-raised-button color="accent" type="button" [disabled]="saving" (click)="clear()">
    Clear Schedule
  </button>
  <button *ngIf="!alreadySent"
          mat-raised-button color="primary" type="button" [disabled]="!canSave" (click)="save()">
    <mat-icon>schedule_send</mat-icon>
    Save Schedule
  </button>
</mat-dialog-actions>
